import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import HtmlEmbed from "@/components/HtmlEmbed";

export default function Application() {
  const [embed, setEmbed] = useState(null);
  useEffect(() => { api.get("/embeds/application").then((r) => setEmbed(r.data)).catch(() => {}); }, []);
  return (
    <>
      <SEO title="Become a VoiceOverKid — Apply" path="/apply"
        description="Apply to join VoiceOverKids. Submit your child's details to be considered for our international child voice-over agency." />
      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Applications</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Become a VoiceOverKid</h1>
          <p className="mt-3 max-w-2xl text-zinc-300">Interested in joining our international network of young voice talent? Complete the application below.</p>
        </div>
      </section>
      <section className="container-x section-y max-w-3xl">
        {embed && embed.html ? (
          <HtmlEmbed html={embed.html} />
        ) : (
          <div className="rounded-2xl border border-zinc-200 bg-white p-10 text-center text-zinc-600">
            Our application form will appear here soon. In the meantime, email <a href="mailto:bookings@voiceoverkids.agency" className="text-brand-violet font-semibold">bookings@voiceoverkids.agency</a>.
          </div>
        )}
      </section>
    </>
  );
}
